import React, { useState, useRef, useMemo } from "react";
import JoditEditor from "jodit-react";
import { folderDate } from "../../../helpers/formatBlog";

export default ({ value, onTextChange }) => {
  const editor = useRef(null);
  const [content, setContent] = useState("");
  // console.log(db.token);
  const user = JSON.parse(localStorage.getItem("au") || "{}");
  const config = {
    readonly: false, // all options from https://xdsoft.net/jodit/doc/
    // preset: "inline",
    uploader: {
      url: `${process.env.API_BASE_URL}/api/storage/upload`, //your upload api url
      insertImageAsBase64URI: false, // not inster base64
      imagesExtensions: ["jpg", "png", "jpeg", "gif"],
      headers: {
        authorization: user.aut,
        apiKey: process.env.API_KEY,
        // "Content-Type": "multipart/form-data",
        // "token":`${db.token}`
      },
      filesVariableName: function (t) {
        return "files";
      },
      // withCredentials: true,
      pathVariableName: `images/${folderDate}`,
      format: "json",
      method: "POST",
      prepareData: function (formdata) {
        formdata.append("destination", `images/${folderDate}`);
        return formdata;
      },
      isSuccess: function (resp) {
        return resp;
      },
      getMessage: function (e) {
        return void 0 !== e.data.messages && Array.isArray(e.data.messages)
          ? e.data.messages.join("")
          : "";
      },
      error: function (e) {
        console.log("Error uploading image: ", e);
      },
      process: function (resp) {
        return {
          path: resp.results[0],
          baseurl: resp.results[0],
          error: resp.error,
          msg: resp.message,
        };
      },
      defaultHandlerSuccess: function (data, resp) {
        this.selection.insertImage(data.baseurl);
      },
    },

    defaultActionOnPaste: "insert_clear_html",
    image: {
      editTitle: true,
      editAlt: true,
      editSize: false,
      showPreview: true,
    },

    imageDefaultWidth: "auto",
    defaultMode: "1",
    toolbarSticky: false,
    askBeforePasteHTML: false,
    askBeforePasteFromWord: false,
    toolbarInlineForSelection: true,
    showPlaceholder: false,
    buttons:
      "bold,italic,underline,strikethrough,eraser,superscript,subscript,ul,ol,indent,outdent,left,font,fontsize,paragraph,brush,image",
  };

  const onInputChange = (inputValue) => onTextChange(inputValue);

  return useMemo(
    () => (
      <JoditEditor
        ref={editor}
        value={value}
        config={config}
        tabIndex={1} // tabIndex of textarea
        onBlur={(newContent) => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
        onChange={(newContent) => onInputChange(newContent)}
        askBeforePasteHTML={false}
      />
    ),
    []
  );
};
